import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: "'Poppins', sans-serif",
    },
    palette: {
        primary: {
            main: '#504fa1',
            light: '#b5dcf2',
        },
        secondary: {
            main: '#32a1da',
            light: '#b5dcf2',
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    scrollbarWidth: "thin",
                    scrollbarColor: "#bdbdbd transparent",
                },

                "*::-webkit-scrollbar": {
                    width: "5px",
                    height: "5px",
                },

                "*::-webkit-scrollbar-thumb": {
                    backgroundColor: "#bdbdbd",
                    borderRadius: "10px",
                },

                "*::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#b5dcf2',
                    color: 'black',
                    textTransform: 'none',
                    // '&:hover': {
                    //     backgroundColor: '#187cb0',
                    // },
                },
            },
        },

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    // display: 'none',
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '40px',
                    border: '1px solid lightgrey',
                    // paddingTop: '0px !important',
                    // paddingBottom: '0px !important',
                    borderRadius: '5px',
                    '&:before, &:after': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontSize: '13px',
                    // padding:0
                },
            },
        },

        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                },
            },
        },

        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    "&:before": { display: "none" },
                },
            },
        },

        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    backgroundColor: "#b5dcf2",
                    flexDirection: "row-reverse",
                    minHeight: 48,
                    "& .MuiAccordionSummary-content": {
                        margin: "12px 0",
                    },
                    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                        transform: "rotate(0deg)",
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        transform: "rotate(0deg)",
                    },
                },
            },
        },


    },
});

export default theme;
